import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'

const json = {
	1: {
		// Exercise num
		unit: 'Unit 8',
		id: '4WB-U8-P56-E1',
		audio: '',
		hideBtnFooter: true,
		// exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '1',
				title: 'Find and circle the words.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
       
            <div> <img style='width:23cm' src='img/FriendsPlus/Page56/E1/1.jpg' /> </div>
          `,
				answer: [''],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 8',
		id: '4WB-U8-P56-E2',
		audio: 'Audios/Track 30.mp3',
		video: '',
		component: T6,
		component: MatchDots,
		exerciseKey: 'img/FriendsPlus/Page56/E2/Key/E2answerKey.png',
		titleQuestion: [
			{
				num: '2',
				title:
					"Listen and match. There are two extra pictures. <headphone name='30' src='Audios/Track 30.mp3'></headphone>",
				color: '#2E479B',
			},
		],
		question: {
			DrawLines: {
				// multipleLine: true,
				boxMatch: [
					//mid
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '261px',
							left: '273px',
							width: 76,
							height: 26,
							//backgroundColor: 'blue',
							// border: "1px solid",
						},
					}, //0
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '300px',
							left: '273px',
							width: 76,
							height: 26,
							//backgroundColor: 'red',
							// border: "1px solid",
						},
					}, //1
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '337px',
							left: '279px',
							width: 88,
							height: 26,
							//backgroundColor: 'yellow',
							// border: "1px solid",
						},
					}, //2
					//left
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '112px',
							left: '82px',
							width: 137,
							height: 151,
							//backgroundColor: 'pink',
							// border: "1px solid",
						},
					}, //3
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '281px',
							left: '85px',
							width: 137,
							height: 151,
							//backgroundColor: 'blue',
							// border: "1px solid",
						},
					}, //4
					//right
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '108px',
							left: '528px',
							width: 168,
							height: 118,
							//backgroundColor: 'red',
							// border: "1px solid",
						},
					}, //5
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '281px',
							left: '528px',
							width: 168,
							height: 123,
							//backgroundColor: 'yellow',
							// border: "1px solid",
						},
					}, //6
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '458px',
							left: '528px',
							width: 168,
							height: 118,
							//backgroundColor: 'black',
							// border: "1px solid",
						},
					}, //7
				],
				answers: ['0-7', '1-6', '2-3'],
				initialValue: [],
			},
			Layout: `
      <img style='padding-top:30px;margin-bottom: 30px; width: 17cm; height: 15cm' src="img/FriendsPlus/Page56/E2/1.jpg" />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />

          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />

          
      `,
		},
	},
}

export default json
